module.exports = __webpack_public_path__ + "media/clock-ff3babe2.svg";